export const typeVariable = [
  { value: "S", label: "String" },
  { value: "I", label: "Inteiro" },
  { value: "N", label: "Numérico" },
  { value: "D", label: "Data" }
];

export const typeEstado = [
  { label: "AC", value: "AC" },
  { label: "AL", value: "AL" },
  { label: "AP", value: "AP" },
  { label: "AM", value: "AM" },
  { label: "BA", value: "BA" },
  { label: "CE", value: "CE" },
  { label: "DF", value: "DF" },
  { label: "ES", value: "ES" },
  { label: "GO", value: "GO" },
  { label: "MA", value: "MA" },
  { label: "MT", value: "MT" },
  { label: "MS", value: "MS" },
  { label: "MG", value: "MG" },
  { label: "PA", value: "PA" },
  { label: "PB", value: "PB" },
  { label: "PR", value: "PR" },
  { label: "PE", value: "PE" },
  { label: "PI", value: "PI" },
  { label: "RJ", value: "RJ" },
  { label: "RN", value: "RN" },
  { label: "RO", value: "RO" },
  { label: "RR", value: "RR" },
  { label: "RS", value: "RS" },
  { label: "SC", value: "SC" },
  { label: "SP", value: "SP" },
  { label: "SE", value: "SE" },
  { label: "TO", value: "TO" }
];

export const tipoBaixa = [
  { value: "F", label: "Financeira" },
  { value: "C", label: "Cancelamento" },
  { value: "O", label: "Outras" },
  { value: "P", label: "Parcelamento" },
  { value: "S", label: "Suspensão" }
];

export const tipoSimNao = [{ value: "Sim", label: "Sim" }, { value: "Não", label: "Não" }];

export const tipoSimNaoAbreviado = [{ value: "S", label: "Sim" }, { value: "N", label: "Não" }];

export const tipoSimNaoInt = [{ value: 1, label: "Sim" }, { value: 0, label: "Não" }];

export const tipoStatus = [{ value: "Ativo", label: "Ativo" }, { value: "Inativo", label: "Inativo" }];

export const tipoStatusBit = [{ value: 1, label: "Ativo" }, { value: 0, label: "Inativo" }];

export const tipoLoteamento = [{ value: "L", label: "Loteamento" }, { value: "B", label: "Bairro" }, { value: "C", label: "Condomínio" }];

export const denominacaoLogradouro = [{ value: "1", label: "Oficializado" }, { value: "2", label: "Denominado" }];

export const tipoJurosAbreviado = [
  { value: "N", label: "Não" },
  { value: "S", label: "orig + cor" },
  { value: "M", label: "orig + cor + multa" },
  { value: "O", label: "original" },
  { value: "D", label: "orig + cor dtorigem" },
  { value: "Y", label: "orig  dtcorrecao" },
  { value: "R", label: "orig + cor dtcorrecao" },
  { value: "G", label: "orig + cor + multa messeguinte" }
];

export const tipoMultaAbreviado = [
  { value: "N", label: "Não" },
  { value: "S", label: "Orig + Cor + Juros" },
  { value: "C", label: "Orig + Cor" },
  { value: "O", label: "Orig" }
];

export const tipoProgressivaAbreviado = [{ value: "M", label: "Mensal" }, { value: "D", label: "Diaria" }, { value: "A", label: "Anual" }];

export const tipoFracaoJurosAbreviado = [
  { value: "S", label: "Fração do Mês" },
  { value: "N", label: "Data Vencimento" },
  { value: "M", label: "Virada do Mês" }
];

export const tipoJurosVariacaoAbreviado = [{ value: "M", label: "Mensal" }, { value: "D", label: "Diaria" }];

export const diaSemanaAbreviado = [
  { value: "Seg", label: "Segunda-Feira" },
  { value: "Ter", label: "Terça-Feira" },
  { value: "Qua", label: "Quarta-Feira" },
  { value: "Qui", label: "Quinta-Feira" },
  { value: "Sex", label: "Sexta-Feira" },
  { value: "Sab", label: "Sábado" },
  { value: "Dom", label: "Domingo" }
];

export const tipoValorAbreviado = [
  { value: "O", label: "Original" },
  { value: "C", label: "Correção" },
  { value: "J", label: "Juros" },
  { value: "M", label: "Multa" },
  { value: "I", label: "Diferença A Maior" }
];

export const situacaoExtenso = [{ value: "Ativo", label: "Ativo" }, { value: "Inativo", label: "Inativo" }];

export const situacaoNumber = [{ value: 1, label: "Ativo" }, { value: 0, label: "Inativo" }];

export const tipoPessoa = [{ value: "F", label: "Fisica" }, { value: "J", label: "Jurídica" }];

export const tipoPessoaNumber = [{ value: 1, label: "Fisica" }, { value: 2, label: "Jurídica" }];

export const regime = [
  { value: "V", label: "Variável" },
  { value: "F", label: "Fixo" },
  { value: "E", label: "Estimado" },
  { value: "N", label: "Não Incidente" }
];

export const tipoOperacao = [{ value: "1", label: "Entrada" }, { value: "-1", label: "Saída" }];

export const tipoUsuario = [{ value: "G", label: "Grupo" }, { value: "U", label: "Usuário" }];

export const tipoCertidao = [
  { value: "N", label: "Negativa" },
  { value: "P", label: "Positiva" },
  { value: "X", label: "Positiva c/ efeito Negativa" },
  { value: "V", label: "Valor Venal" },
  { value: "W", label: "Valor Venal de ITBI" },
  { value: "C", label: "Comprobatória" },
  { value: "Y", label: "Protesto" },
  { value: "O", label: "Outras" }
];

export const tipoPropriedadeBanco = [
  { value: "S", label: "String" },
  { value: "I", label: "Inteiro" },
  { value: "N", label: "Numérico" },
  { value: "D", label: "Data" }
];

export const tipoDivida = [
  { value: "A", label: "Ativa" },
  { value: "C", label: "Corrente" },
  { value: "J", label: "Judicial" },
  { value: "N", label: "Nenhum" }
];
export const tipoAcao = [{ value: "I", label: "Inclusão" }, { value: "U", label: "Alteração" }, { value: "D", label: "Exclusão" }];

export const setorOrigem = [
  { value: "MOBILIARIO", label: "Mobiliário" },
  { value: "IMOBILIARIO", label: "Imobiliário" },
  { value: "CONTRIBUINTE", label: "Contribuinte" },
  { value: "AUTODEINFRACAO", label: "Auto de Infração" },
  { value: "TAXASDIVERSAS", label: "Taxa Diversa" },
  { value: "ITBI", label: "ITBI" },
  { value: "ACAOFISCALTERMO", label: "Ação Fiscal Termo" },
  { value: "AJUIZAMENTO", label: "Ajuizamento" },
  { value: "MELHORIA", label: "Melhoria" },
  { value: "PROJETO", label: "Projeto" }
];

export const setorOrigemCertidao = [
  { value: "MOBILIARIO", label: "Mobiliário" },
  { value: "IMOBILIARIO", label: "Imobiliário" },
  { value: "CONTRIBUINTE", label: "Contribuinte" }
];

export const tipoReferencia = [{ value: "S", label: "Sintética" }, { value: "A", label: "Analítica" }];

export const situacaoPlanoDesconto = [
  { value: "Ativo", label: "Ativo" },
  { value: "Inativo", label: "Inativo" },
  { value: "Suspenso", label: "Suspenso" }
];

export const situacaoParcelaPlanoDesconto = [
  { value: "Normal", label: "Normal" },
  { value: "Dívida Ativa", label: "Dívida Ativa" },
  { value: "Em Ajuizamento", label: "Em Ajuizamento" },
  { value: "Ajuizada", label: "Ajuizada" },
  { value: "Inscritos", label: "Inscritos" },
  { value: "Todas", label: "Todas" }
];

export const setorOrigemPlanoDesconto = [
  { value: "Todos", label: "Todos" },
  { value: "Contribuinte", label: "Contribuinte" },
  { value: "Imobiliário", label: "Imobiliário" },
  { value: "Mobiliário", label: "Mobiliário" },
  { value: "Água", label: "Água" },
  { value: "Rural", label: "Rural" }
];

export const sistemaPlanoDesconto = [{ value: "Todos", label: "Todos" }];

export const tipoStatusCheck = [{ value: "Ativo", label: "Ativo", checkItem: true }, { value: "Inativo", label: "Inativo", checkItem: false }];

export const tipoEvento = [
  { value: "T", label: "Taxas" },
  { value: "I", label: "Impostos" },
  { value: "O", label: "Outros" },
  { value: "N", label: "Não Tributária" }
];

export const tipoMeda = [{ value: "REAL", label: "REAL" }];

export const origemDeca = [{ value: 0, label: "Solicitante" }, { value: 1, label: "Prefeitura" }]
